<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="avatar-container">
        <el-image :src="memberInfo.avatar" :preview-src-list="[memberInfo.avatar]" fit="cover" />
      </div>
    </el-col>
    <el-col :span="24">
      <el-descriptions :label-style="{fontWeight:600}" :column="device==='mobile' ? 1 : 2" :colon="false" size="medium" border>
        <el-descriptions-item label="ID">{{ memberInfo.id }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ memberInfo.nickName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ memberInfo.mobile }}</el-descriptions-item>
        <el-descriptions-item label="分享码">{{ memberInfo.shareCode }}</el-descriptions-item>
        <el-descriptions-item label="邀请人">{{ memberInfo.inviterName }}</el-descriptions-item>
        <el-descriptions-item label="邀请码">{{ memberInfo.inviteCode }}</el-descriptions-item>
        <el-descriptions-item label="身份等级">{{ memberInfo.gradeName }}</el-descriptions-item>
        <el-descriptions-item label="消费等级">{{ memberInfo.consumerName }}</el-descriptions-item>
        <el-descriptions-item label="绑定状态">{{ memberInfo.bindingStatus === 1 ? '已绑定' : '未绑定' }}</el-descriptions-item>
        <el-descriptions-item label="绑定位置">{{ memberInfo.bindingLocation }}</el-descriptions-item>
        <el-descriptions-item label="成为粉丝时间">{{ memberInfo.fansDate }}</el-descriptions-item>
        <el-descriptions-item label="成为会员时间">{{ memberInfo.memberDate }}</el-descriptions-item>
        <el-descriptions-item label="成为SVIP时间">{{ memberInfo.serviceDate }}</el-descriptions-item>
        <el-descriptions-item label="拥有分享收益时间">{{ memberInfo.privilegeDate }}</el-descriptions-item>
        <el-descriptions-item label="成为消费者时间">{{ memberInfo.consumerDate }}</el-descriptions-item>
        <el-descriptions-item label="成为消费商时间">{{ memberInfo.retailerDate }}</el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMemberDetail } from '@/api/member'

export default {
  name: 'UserDetail',
  props: {
    memberId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      memberInfo: {}
    }
  },
  computed: mapGetters(['device']),
  mounted() {
    getMemberDetail(this.memberId).then(response => {
      this.memberInfo = response
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
  .avatar-container {
    display: block;
    text-align: center;
    margin-bottom: 20px;
    .el-image {
      width: 132px;
      height: 132px;
      border-radius: 50%;
    }
  }
</style>
